module.exports = __webpack_public_path__ + "img/fh.ac6e20cc.svg";